import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/CreateDomain/CreateDomain";
export * from "./types/DeleteDomain/DeleteDomain";
export * from "./types/DeleteDomainCustomization/DeleteDomainCustomization";
export * from "./types/GetDomain/GetDomain";
export * from "./types/GetDomainCustomization/GetDomainCustomization";
export * from "./types/GetRecord/GetRecord";
export * from "./types/ListDomains/ListDomains";
export * from "./types/ListRecordProviders/ListRecordProviders";
export * from "./types/UpdateDomain/UpdateDomain";
export * from "./types/UpdateDomainCustomization/UpdateDomainCustomization";
const endpoints = {
    global: "https://domain.fromsmash.co",
};
config.setHosts("domain", endpoints, false);
export class Domain extends Client {
    constructor(params = {}) {
        super({ service: "domain", ...params, type: "global", userAgent: "@smash-sdk/domain@1.0.0-alpha.3" });
        this.errors = errors;
    }
    createDomain(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/domain",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        domain: params["domain"],
                        options: params["options"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateDomainError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteDomain(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/domain/:domainId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        domainId: params["domainId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteDomainError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteDomainCustomization(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/domain/:domainId/customization",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        domainId: params["domainId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteDomainCustomizationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getDomain(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/domain/:domainId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        domainId: params["domainId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetDomainError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getDomainCustomization(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/domain/:domainId/customization",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        domainId: params["domainId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetDomainCustomizationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getRecord(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/record/:name",
                    headers: {},
                    pathParameters: {
                        name: params["name"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetRecordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listDomains() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/domains",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListDomainsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listRecordProviders(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/record/:name/providers",
                    headers: {},
                    pathParameters: {
                        name: params["name"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListRecordProvidersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateDomain(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/domain/:domainId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        domainId: params["domainId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        domain: params["domain"],
                        options: params["options"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateDomainError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateDomainCustomization(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/domain/:domainId/customization",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        domainId: params["domainId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        logo: params["logo"],
                        background: params["background"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateDomainCustomizationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Domain.errors = errors;
